<template>
  <div class="goods-box mini-width">
    <div class="w-1400">
      <div class="goods-title">
        <title-home title="商城精选" English="Shopping Mall Select"></title-home>
        <!-- <div class="big-title">商城精选</div>
        <div class="big-title-text">Shopping Mall Select</div> -->
      </div>
      <div class="goods-list-box" v-if="goosList.length>0">
        <div class="goods-list-item hit-cursor" v-for="(item, index) in goosList" :key="index">
          <!-- @click.stop="goQuote(item.id)" -->
          <div class="goods-list-item-image">
            <img :src="item.image" alt="商品图片"/>
          </div>
          <div class="goods-list-item-name ">{{ item.product_name }}</div>
          <div class="goods-list-item-cas">CAS:{{ item.cas_no }}</div>
          <div class="goods-list-item-button hit-cursor" @click="goShopDetail(item)">
            立即购买
          </div>
        </div>

      </div>
      <div v-if="goosList.length==0">
        <el-empty description="暂无商品，敬请期待"></el-empty>
      </div>
      <div class="goods-look">
        <div class="goods-look-text hit-cursor" @click="goShop">
          查看更多
          <img src="../../static/index/more.png" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getMallChoice} from "@/api/modules/home";
import TitleHome from "@/components/Title/title-home.vue";

export default {
  components: {
    TitleHome,
  },
  props: {},
  data() {
    return {
      goosList: [],
    }
  },
  mounted() {
    this.getMallChoice();
  },
  methods: {
    // 商城查看更多
    goShop() {
      this.$router.push("/shop");
    },

    // 跳转商城商品详情
    goShopDetail(item) {
      if (this.mixCheckLogin() && this.mixCheckUserAudit()) {
        this.$router.push({
          path: "/shop/shopDetail",
          query: {
            id: item.id,
          },
        });
      }
    },
    // 获取商城精选
    async getMallChoice() {
      let res = await getMallChoice({is_recommend: 1, page: 1, limit: 4});
      this.goosList = res.data.data.data;
    },
  }
}

</script>
<style scoped lang="scss">
.goods-box {
  width: 100%;
  // height: 728px;
  background: #f8f8f8;
  padding: 40px 0;
  box-sizing: border-box;

  .goods-title {
    text-align: center;

    .big-title {
      font-weight: 800;
      font-size: 32px;
      color: #00112b;
      line-height: 53px;
      margin-bottom: 10px;
    }

    .big-title-text {
      font-weight: 500;
      font-size: 20px;
      color: #5f616c;
    }
  }

  .goods-list-box {
    margin: 40px 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* 5 列，每列等宽 */

    .goods-list-item {
      width: 303px;
      height: 333px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
      text-align: center;

      .goods-list-item-image {
        width: 100%;
        height: 177px;
        display: flex;
        justify-content: center;

        img {
          width: 95%;
          height: 95%;
          margin: auto;
          object-fit: contain;
        }
      }

      .goods-list-item-name {
        font-weight: bold;
        font-size: 16px;
        color: #424242;
        margin-bottom: 15px;
        padding: 0 20px;
        display: -webkit-box;
        /* 使用WebKit的盒子模型 */
        -webkit-line-clamp: 1;
        /* 限制显示两行 */
        -webkit-box-orient: vertical;
        /* 设置盒子方向为垂直 */
        overflow: hidden;
        /* 超出部分隐藏 */
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */

      }

      .goods-list-item-cas {
        font-size: 14px;
        color: #424242;
        margin-bottom: 15px;
      }

      .goods-list-item-button {
        width: 100px;
        height: 40px;
        font-size: var(--font-size-default-14);
        background: linear-gradient(306deg, #578fff 0%, #236cff 100%);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #2979f1;
        text-align: center;
        line-height: 40px;
        color: #ffffff;
        margin-left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .goods-look {
    .goods-look-text {
      width: 200px;
      height: 45px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #0c60e6;
      color: #0c60e6;
      line-height: 45px;
      text-align: center;
      margin-left: 50%;
      transform: translateX(-50%);

      img {
        width: 13px;
        height: 13px;
        margin-left: 10px;
        vertical-align: middle;
      }
    }
  }
}

</style>
